import BlockContainerAction from '../../../actions/blockContainerAction';
import useBlock from '../../../hook/block/useBlock';
import usePath from '../../../hook/path/usePath';
import useShiftKey from '../../../hook/useShiftKey';

// Component for create the second part of the link when you click on it
function BlockLinkStart({className, style, parent_block_id, object_id}) {

    const { createTmpPath, updateMouse, deleteAllSelectedBlock } = BlockContainerAction();
    const { getChildPosition, getBlockInformation } = useBlock();
    const { deletePath } = usePath();
    const { shiftKey } = useShiftKey();

    const onClick = (e) => {
        if(shiftKey) {
            e.preventDefault();
            return
        }
        const {x, y} = getChildPosition(parent_block_id, object_id);
        const { paths_in } = getBlockInformation(parent_block_id);
        const path_find = paths_in.filter(path => path.child_block_id == object_id).pop()

        if(!path_find) {
            deleteAllSelectedBlock();
            createTmpPath(x, y, parent_block_id, object_id);
            updateMouse(e.clientX, e.clientY);
            return;
        }

        deletePath(path_find.path_id);
    };

    const changePathColor = (color) => {
        const {paths_in} = getBlockInformation(parent_block_id);
        const path_find = paths_in.filter(path => path.child_block_id == object_id).pop()
        if(!path_find) {
            return;
        }

        const pathDom = document.getElementById(path_find.path_id);
        if(pathDom == null) {
            return;
        }

        pathDom.style.stroke = color
    }

    const onMouseEnter = () => shiftKey == false && changePathColor("var(--pink)")

    const onMouseLeave = () => shiftKey == false && changePathColor("")

    const {paths_in} = getBlockInformation(parent_block_id);
    const path_find = paths_in.filter(path => path.child_block_id == object_id).pop()
    style = style == undefined ? {} : style;
    if(shiftKey) style.cursor = 'not-allowed';
    else style.cursor = path_find ? 'pointer' : 'alias';
    return <div className={className} style={{...style}} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}/>
}

export default BlockLinkStart;